import React from 'react';
import { CTAButton } from '../ui/CTAButton';
import { Check, ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-[#FDFCF8] pt-12 pb-20 md:pt-20 md:pb-28" data-id="element-31">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 h-[500px] w-[500px] rounded-full bg-teal-50/50 blur-3xl" data-id="element-32" />
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 h-[400px] w-[400px] rounded-full bg-orange-50/50 blur-3xl" data-id="element-33" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-34">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-35">
          {/* Content */}
          <div className="flex-1 max-w-2xl text-center lg:text-left" data-id="element-36">
            <div className="inline-block px-4 py-1.5 mb-6 rounded-full bg-teal-50 border border-teal-100" data-id="element-37">
              <span className="text-sm font-semibold text-teal-800 tracking-wide uppercase" data-id="element-38">
                For Frustrated Resin Crafters
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-stone-900 leading-[1.1] mb-6" data-id="element-39">
              Are You Afraid of{' '}
              <span className="text-[#D97757] italic" data-id="element-40">Wasting Money</span> with
              Resin?
            </h1>

            <p className="text-lg md:text-xl text-stone-600 mb-8 leading-relaxed" data-id="element-41">
              Create smooth, sell-ready pieces in just 7 days — even if yours
              keep getting bubbles or turning sticky.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start mb-10" data-id="element-42">
              {['Anti-bubble protocol', 'Sticky resin diagnostic', 'Step-by-step method'].map((item, i) => <div key={i} className="flex items-center gap-2 bg-white/80 px-3 py-2 rounded-lg shadow-sm border border-stone-100" data-id="element-43">
                  <Check className="h-4 w-4 text-teal-600 flex-shrink-0" data-id="element-44" />
                  <span className="text-sm font-medium text-stone-700" data-id="element-45">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-46">
              <CTAButton size="lg" className="min-w-[280px]" data-id="element-47">
                Start The 7-Day System
              </CTAButton>

              <div className="flex items-center gap-4 text-xs md:text-sm text-stone-500" data-id="element-48">
                <span className="flex items-center gap-1" data-id="element-49">
                  <ShieldCheck className="h-4 w-4 text-teal-600" data-id="element-50" />
                  Beginner Friendly
                </span>
                <span className="w-1 h-1 rounded-full bg-stone-300" data-id="element-51" />
                <span data-id="element-52">Instant Access</span>
                <span className="w-1 h-1 rounded-full bg-stone-300" data-id="element-53" />
                <span data-id="element-54">Money-Back Guarantee</span>
              </div>
            </div>
          </div>

          {/* Visual */}
          <div className="flex-1 w-full max-w-lg lg:max-w-none relative" data-id="element-55">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white bg-stone-200 aspect-[4/3]" data-id="element-56">
              {/* Main Mockup Image Placeholder */}
              <img src="https://images.unsplash.com/photo-1516975080664-ed2fc6a32937?q=80&w=2070&auto=format&fit=crop" alt="Resin workshop setting with tablet and guide" className="w-full h-full object-cover opacity-90" data-id="element-57" />

              {/* Overlay Gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-stone-900/20 to-transparent" data-id="element-58" />

              {/* Floating Inset - Problem/Solution */}
              <div className="absolute -bottom-6 -left-6 md:bottom-8 md:-left-8 bg-white p-3 rounded-xl shadow-xl max-w-[200px] transform rotate-[-2deg]" data-id="element-59">
                <div className="flex gap-2 mb-2" data-id="element-60">
                  <div className="w-1/2 aspect-square bg-red-100 rounded-md overflow-hidden relative" data-id="element-61">
                    <div className="absolute inset-0 flex items-center justify-center text-xs text-red-800 font-bold bg-red-200/50" data-id="element-62">
                      Bubbles
                    </div>
                  </div>
                  <div className="w-1/2 aspect-square bg-teal-100 rounded-md overflow-hidden relative" data-id="element-63">
                    <div className="absolute inset-0 flex items-center justify-center text-xs text-teal-800 font-bold bg-teal-200/50" data-id="element-64">
                      Smooth
                    </div>
                  </div>
                </div>
                <p className="text-xs font-bold text-center text-stone-700" data-id="element-65">
                  From Fail to Perfect
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}